// extracted by mini-css-extract-plugin
export default {"modal":"EscrowWarningModal-module__modal--FaBqo","actionsButtons":"EscrowWarningModal-module__actionsButtons--EQ1Cd","actionButton":"EscrowWarningModal-module__actionButton--ho6bG"};